import { LanguagePhrases } from '../models/LanguagePhrases';
import { termsConditionArabicGenerated } from './termsConditionArabic.generated';

export const arabicPhrases: LanguagePhrases = {
	yesterday: 'أمس',
	daysAgo: 'منذ ايام',
	today: 'اليوم',
	signIn: 'تسجيل الدخول',
	home: 'الرئيسية',
	signinTitle: 'قم بتسجيل الدخول إلى حساب الدفع الخاص بك',
	signinDesc: 'قم بتسجيل الدخول باستخدام بيانات الاعتماد الخاصة ببوابة العميل',
	email: 'البريد الإلكتروني',
	password: 'كلمة المرور',
	forgotPassword: 'نسيت كلمة المرور',
	emailRequired: 'يجب ألا يكون حقل البريد الإلكتروني فارغًا!',
	passwordRequired: 'يجب ألا يكون حقل كلمة المرور فارغًا!',
	somethingWrong: 'حدث خطأ ما!',
	emailMsg: 'يرجى التأكد من صحة عنوان البريد الإلكتروني الخاص بك!',
	passwordMsg:
		'تأكد من أن كلمة المرور لديك تحتوي على الأقل 8 أحرف ، وتتضمن حرفًا كبيرًا وحرفًا صغيرًا وعلامة واحدة على الأقل.',
	becomeMerchant: ' كن تاجراً ',
	yourAccountIsInactive: 'حسابك غير نشط. يرجى الاتصال بالشركة لتنشيطه ',
	regularUserHome: 'الصفحة الرئيسية للمستخدم العادي',
	merchantHome: ' الرئيسية',
	merchantsOffer: 'عروض التجار',
	notificationsHeading: 'الإشعارات',
	searchInMerchantsTable: 'البحث في جدول التجار',
	problemLoadingListOfMerchants: 'توجد مشكلة في تحميل قائمة التجار',
	name: 'اسم',
	rating: 'تقييم',
	totalReview: 'جميع التقييمات',
	ordersCompleted: 'الطلبات المنجزة',
	price: 'السعر',
	available: 'متاح',
	minLimit: 'الحد الأدنى',
	maxLimit: 'الحد الأقصى',
	buy: 'شراء',
	sell: 'بيع',
	accountVerification: 'تأكيد الحساب',
	problemLoadingMerchant: 'هناك بعض المشاكل في تحميل معلومات التاجر',
	merchantInfo: 'معلومات التاجر',
	wantToBuy: 'أريد ان اشتري',
	wantToSell: 'أريد أن أبيع',
	amountIsRequired: 'المبلغ مطلوب',
	willReceive: 'سوف استلم',
	willSend: 'سوف أرسل',
	paymentMethod: 'طرق الدفع ',
	paymentMethodIsRequired: 'طريقة الدفع مطلوبة',
	valueInRangeError: 'يجب أن يكون المبلغ في هذا النطاق',
	merchants: 'التجار',
	countryCurrency: 'الدولة / العملة',
	currency: 'العملة',
	paymentMethods: 'طرق الدفع',
	myDetails: 'تفاصيلي',
	changePassword: 'تغيير كلمة المرور',
	myDetailsForm: 'نموذج التفاصيل الخاصة بي',
	myProfile: 'ملفي الشخصي',
	firstName: 'الاسم الأول',
	surname: 'اسم العائلة',
	phone: 'هاتف',
	address: 'عنوان',
	city: 'مدينة',
	zip: 'zip',
	state: 'ولاية',
	country: 'دولة',
	registrationDate: 'تاريخ التسجيل',
	newPassword: 'كلمة المرور الجديدة',
	currentPassword: 'كلمة المرور الحالية',
	confirmPassword: 'تأكيد كلمة المرور',
	updatePassword: 'تحديث كلمة السر',
	changePasswordForm: 'نموذج تغيير كلمة المرور',
	yourPasswordGotUpdated: 'تم تحديث كلمة المرور',
	somethingWentWrongWithUpdatingPassword: 'حدث خطأ في تحديث كلمة المرور',
	pleaseMakeSurePasswordIsValid:
		'يرجى التأكد من أن كلمة مرورك تتضمن على الأقل حرفًا كبيرًا وحرفًا صغيرًا وحرفًا خاصًا وأن يكون طول كلمة المرور 8 على الأقل وباللغة الإنكليزية',
	twoPasswordsDoNotMatch: 'يجب أن تكون كلمتا المرور متطابقتين',
	myOffers: 'العروض',
	yourSellerFormGotUpdated: 'تم تحديث عرض البيع الخاص بك',
	somethingWentWrongWithUpdatingSellerForm: 'حدث خطأ في تحديث نموذج البائع',
	yourBuyerFormGotUpdated: ' تم تحديث عرض الشراء الخاص بك',
	somethingWentWrongWithUpdatingBuyerForm: 'حدث خطأ في تحديث نموذج المشتري',
	sellOffer: 'عرض البيع',
	profitRatio: 'نسبة الربح',
	profitRatioIsRequired: 'نسبة الربح مطلوبة',
	profitRatioInRangeError: 'نسبة الربح لا يمكن أن تكون أكبر من',
	atleastSelectOneMethod: 'الرجاء تحديد طريقة دفع واحدة على الأقل',
	maximumAmount: 'الحد الأقصى للمبلغ',
	valueMustBePositive: 'يجب أن تكون القيمة موجبة',
	mustBeGreaterThanMinValue: 'يجب أن تكون القيمة أكبر من الحد الأدنى للقيمة',
	minimumAmount: 'الحد الأدنى للمبلغ',
	mustBeLessThanMaxValue: 'يجب أن تكون القيمة أقل من الحد الأقصى للقيمة',
	visibleForUsers: 'مرئي للمستخدمين',
	no: 'لا',
	yes: 'نعم',
	update: 'تحديث',
	buyOffer: 'عرض الشراء',
	logout: 'تسجيل خروج',
	privacyPolicy: 'سياسة الخصوصية',
	companies: 'شركات',
	news: 'أخبار',
	termsOfUse: 'شروط الاستخدام',
	merchantsOfferSubtitle: 'اكتشف صفقات P2P بدون رسوم واختر وسيلة الدفع المفضلة على منصتنا اليوم!',
	notificationsSubtitle: 'تمكينك مع التنبيهات في الوقت المناسب! ابق على اتصال، ابق على اطلاع.',
	limit: 'الحد',
	countries: 'الدول',
	min: 'الحد الأدنى',
	max: 'ألحد ألاقصى',
	all: 'الكل',
	merchantProfile: 'ملف التاجر',
	availableLimit: 'متاح / حد',
	trade: 'تداوٌل',
	fees: 'رسوم',
	reviews: 'تقيمات',
	buyers: 'المشترون',
	sellers: 'البائعون',
	termsAndConditions: 'الشروط والاحكام',
	unitPrice: 'سعر الوحدة',
	youSale: 'أنت تبيع',
	youReceive: 'مبلغ الإستلام',
	selectPaymentMethods: 'حدد طرق الدفع',
	account: 'حسابات',
	note: 'ملاحظة',
	pleaseWriteYourNote: 'يرجى كتابة ملاحظتك',
	certainPaymentMethodsMayHaveFees: 'قد يكون لبعض طرق الدفع رسوم وحدود يومية يحددها مزود الدفع.',
	youPay: 'مبلغ الدفع',
	orders: 'طلبات',
	welcomeBack: 'مرحباً بعودتك',
	loginToYourAccount: 'تسجيل الدخول إلى حسابك',
	pleaseEnterYourEmail: 'رجاءً أدخل بريدك الإلكتروني',
	enterPassword: 'أدخل كلمة المرور',
	notRegistered: 'غير مسجل؟ ',
	or: 'أو',
	createAnAccount: ' أنشئ حساب',
	readOur: 'اقرأ',
	signinWarningNote:
		'تحذير: الوصول غير المصرح به إلى هذا النظام ممنوع وسيتم مقاضاته بموجب القانون. من خلال الوصول إلى هذا النظام ، فإنك توافق على أنه قد تتم مراقبة أفعالك في حالة الاشتباه في الاستخدام غير المصرح به',
	allRightsReserved: 'كل الحقوق محفوظة',
	availableIsRequired: 'المبلغ المتاح مطلوب',
	somethingWentWrongVerification: 'حدث خطأ ما، يرجى التأكد من أن مستنداتك قد تم قبولها وأن حسابك أصبح مفعلاً',
	myOrders: 'صفقاتي',
	myOrderSubtitle: 'التاريخ يعيد نفسه, يمكنك دائماً إعادة الصفقات بكل سهولة!',
	calculatedPrice: 'السعر النهائي',
	status: 'حاله الطلب',
	dateRange: 'نطاق التاريخ',
	sent: 'مُرسَل',
	recieved: 'مُستَلَم',
	active: 'نشِط',
	pending: 'قيد الانتظار',
	completed: 'مُكتَمِل',
	cancel: 'إلغاء',
	inDispute: 'قيد التنازُع',
	id: 'المعرف',
	quantity: 'الكمية',
	amount: 'المبلغ',
	dateAndTime: 'التاريخ والوقت',
	searchOrder: 'البحث في الطلبات',
	transferPaymentToSeller: 'تحويل المبلغ للبائع',
	pendingSellerToReleasePayment: 'في انتظار الإفراج عن المبلغ',
	orderNumber: 'رقم الطلب',
	timeCreated: 'تاريخ بدء الطلب',
	activeOrder: 'أمر نشط',
	pendingOrder: 'طلب معلق',
	completedOrder: 'الطلب مكتمل',
	cancelledOrder: 'الطلب ملغي',
	buyFrom: 'يشترى من',
	buyUSDFrom: 'شراء دولار أمريكي من',
	buyIQDFrom: 'اشتري دينار عراقي من',
	orderCreatedConfirmation: 'تم إنشاء الطلب. يرجى انتظار تأكيد النظام',
	orderWaitingMessage: 'في انتظار تأكيد الدفع من البائع لإصدار الطلب ، اكتمل 95٪ من طلب هذا البائع في غضون 3 دقائق',
	orderCompletedMessage:
		'تم وضع علامة على الطلب على أنه مكتمل بنجاح. إذا كانت لديك أي مشكلة في الدفع ، فاتصل بالدعم لحل المشكلة',
	youSuccessfullyBought: 'لقد اشتريت بنجاح',
	IQDFrom: 'دينار عراقي من',
	thisOrderHasBeenCancelled: 'تم الغاء هذا الطلب',
	thisOrderIsInDispute: 'هذا الطلب قيد النزاع',
	orderAmount: 'قيمة الطلب',
	youPaid: 'لقد دفعت',
	accountName: 'إسم الحساب',
	orderDetails: 'تفاصيل الطلب',
	payWithZenCash: 'ادفع مع ZenCash',
	selectPaymentCompleted: 'حدد اكتمل الدفع لإبلاغ البائع',
	paymentCompletedNotify: 'اكتمل الدفع ، أبلغ البائع',
	paymentReceived: 'تم استلام المبلغ',
	paymentReleasedAlertTitle: 'تأكيد استلام المبلغ',
	paymentReleasedAlertDescription:
		'يرجى مراجعة لقطة شاشة إثبات الدفع والتأكد من وصول المبلغ فعلياً إلى حسابك أو محفظتك، ثم الضغط على تم استلام المبلغ لإتمام الطلب فوراً',
	fundsReceived: 'تم استلام المبلغ',
	transferFundsAlertTitleToMerchant: 'تحويل المبلغ إلى التاجر',
	transferFundsAlertTitleToClient: 'تحويل المبلغ إلى العميل',
	transferFundsAlertDescription:
		'يرجى تحويل المبلغ حسب بيانات الدفع الظاهرة داخل الدردشة، ثم الضغط على زر تم التسديد لإرفاق إثبات الدفع',
	fundsTransferred: 'تم التسديد',
	BackToHome: 'العودة إلى الصفحة الرئيسية',
	reorder: 'إعادة الطلب',
	contactSupport: 'اتصل بالدعم',
	cancelOrder: 'الغاء الطلب',
	completeYourPayment: 'إتمام الدفع الخاص بك؟',
	note1: 'يُرجى تأكيد أنك قد نجحت في تحويل الأموال إلى البائع',
	note2: 'ملاحظة: لا تتابع إذا لم تكمل الدفع / قد يؤدي هذا إلى تعليق المبلغ',
	rateTheMerchant: 'قيم التاجر',
	orderS: 'طلبات',
	lastSeen: 'اخر ظهور',
	ago: 'منذ',
	yourName: 'اسمك',
	yourEmail: 'بريدك الالكتروني',
	yourPhone: 'هاتفك',
	subject: 'موضوع',
	message: 'رسالة',
	nameIsRequired: 'مطلوب اسم',
	emailIsRequired: 'البريد الالكتروني مطلوب',
	phoneIsRequired: 'الهاتف مطلوب',
	subjectIsRequired: 'الموضوع مطلوب',
	messageIsRequired: 'الرسالة مطلوبة',
	sendMessage: 'أرسل رسالة',
	bestSellers: 'أفضل البائعين',
	maxOrders: 'أعلى الطلبات',
	minOrders: 'أقل الطلبات',
	importantNote: 'ملاحظة هامة',
	confirm: 'تأكيد',
	confirmContactingMerchantInChat:
		'يرجى التأكد من الاتصال بالتاجر قبل إجراء أي دفعة. {{companyName}} لن تكون  مسؤولة عن أي نوع من الخسارة.',
	myAccounts: 'حساباتي',
	myAccountsSubtitle: 'احصل على نظرة واضحة على محفظتك ، بما في ذلك الأرصدة وتفاصيل الحساب.',
	tradingPlatform: 'منصة التداول',
	accountType: 'نوع الحساب',
	accountGroup: 'مجموعة الحساب',
	accountNumber: 'رقم الحساب',
	balance: 'الرصيد',
	onHoldBalance: 'الرصيد المعلق ',
	client: 'عميل',
	emailUs: 'أرسل لنا بريدًا إلكترونيًا',
	merchant: 'تاجر',
	writeMessage: 'اكتب رسالة',
	availability: 'المتوفر',
	buyersTerm: 'شروط وأحكام الشراء',
	sellersTerm: 'شروط وأحكام البائع',
	bankDeposit: 'الإيداع البنكي فقط',
	accHolder: 'صاحب الحساب الأصلي',
	thirdParty: 'غير مقبول الدفع من طرف ثالث',
	wedFri: 'الأربعاء-الجمعة',
	merchantReview: 'تقيمات التاجر',
	apiNotFound: 'لم يتم العثور على واجهة برمجة التطبيقات',
	unableToAuthenticateTheUser: 'جلسة غير صالحة أو منتهية الصلاحية',
	somethingWentWrong: 'هناك خطأ ما',
	constraintViolated: 'تم انتهاك القيد',
	recordIsLinked: 'السجل مرتبط',
	parametersCannotBeNull: 'لا يمكن أن تكون المعلمات فارغة',
	methodArgumentsAreInvalid: 'وسيطات الأسلوب غير صالحة',
	fileUploadingError: 'خطأ في تحميل الملف',
	parameterIsNotValid: 'معلمة الطلب غير صالحة',
	requiredParametersAreMissing: 'المعلمات المطلوبة مفقودة',
	pleaseEnterValidEmailAddress: 'يرجى إدخال عنوان بريد إلكتروني صالح',
	passwordDoesNotMatchRequirements:
		'كلمة المرور لا تتطابق مع المتطلبات: الحد الأدنى 8 والحد الأقصى 16 حرفًا، وتتضمن على الأقل حرفًا كبيرًا واحدًا وحرفًا صغيرًا واحدًا ورقمًا واحدًا وحرفًا خاصًا واحدًا',
	invalidMerchantOfferRequest: 'طلب عرض التاجر غير صالح',
	invalidTradingAccountGroup: 'مجموعة حسابات التداول غير صالحة',
	countryIsNotAllowed: 'البلد غير مسموح به في نظام هذا الموقع ',
	orderNumberProvidedIsInvalid: 'معرف الطلب المقدم غير صالح',
	orderIsClosed: 'الطلب مغلق',
	actionNotApplicable: 'الإجراء غير قابل للتطبيق',
	errorOccurredWhileProcessingYourRequest: 'حدث خطأ أثناء معالجة طلبك',
	problemOccurredWhileLoadingRecords: 'حدثت مشكلة أثناء تحميل السجلات',
	problemOccurredWhileLoadingRecord: 'حدثت مشكلة أثناء تحميل السجل',
	problemOccurredWhileAddingRecord: 'حدثت مشكلة أثناء إضافة السجل',
	problemOccurredWhileUpdatingRecord: 'حدثت مشكلة أثناء تحديث السجل',
	problemOccurredWhileDeletingRecord: 'حدثت مشكلة أثناء حذف السجل',
	recordAlreadyExists: 'السجل موجود من قبل',
	noRecordFound: 'لا يوجد سجلات',
	accessDeniedMissingKyc: 'تم رفض الوصول بسبب فقدان الوثائق',
	invalidCredentials: 'بيانات الاعتماد غير صالحة',
	invalidPaymentMethod: 'طريقة الدفع غير صالحة',
	invalidOfferType: 'نوع العرض غير صالح',
	orderIsInProgress: 'الطلب قيد المعالجة',
	orderReviewIsAlreadyPresent: 'تقيم الطلب موجود بالفعل',
	orderIsClosedMoreThanWeekAgo: 'الطلب مغلق منذ أكثر من أسبوع',
	userIsInactive: 'المستخدم غير نشط',
	userCountryNotAllowed: 'بلد المستخدم غير مسموح به',
	orderIsExpiredOrClosed: 'انتهت صلاحية الطلب أو تم إغلاقه',
	invalidOrderAction: 'إجراء أمر غير صالح',
	onlyOneOrderAllowedAtTime: 'يُسمح بطلب واحد فقط في كل مرة',
	invalidTradingAccount: 'حساب التداول غير صالح',
	merchantBelongsToDifferentCountry: 'لا يمكن التجارة! التاجر ينتمي إلى بلد مختلف',
	orderAmountIsMoreThanAvailableBalance: 'مبلغ الطلب أكثر من الرصيد المتاح!',
	merchantOfferNotAvailable: 'عرض التاجر غير متوفر!',
	amountDoesNotSatisfyAvailableLimit: 'المبلغ لا يلبي الحد المتاح!',
	iraq: 'العراق',
	lebanon: 'لبنان',
	saudi: 'المملكة السعودية',
	egypt: 'مصر',
	jordan: 'الأردن',
	requestWasSentSuccessfully: 'تم ارسال الطلب بنجاح',
	noReviewsForThisMerchant: 'لا توجد تعليقات لدى هذا التاجر',
	problemLoadingListOfOrders: 'حدثت مشكلة أثناء تحميل قائمة الطلبات',
	new: 'جديد',
	cancelled: 'ملغي',
	transferred: 'تم التحويل',
	sellerConfirmed: 'تم تأكيد البائع',
	cancellationRequest: 'طلب بالإلغاء',
	timedOut: 'نافذ التوقيت',
	appealed: 'قيد الإعتراض',
	rejected: 'مرفوض',
	closed: 'مغلق',
	myOffersSubtitle: 'هذه هي العروض التي سيتم تقديمها لعملائك',
	merchantDetails: 'تفاصيل التاجر',
	merchantDetailsDescription:
		'استكشاف أفضل سمات التجار وآرائهم، تقديم تحليلات قيمة لتعزيز تجربتك في التداول بنظام التجارة الذي نوفره لك',
	onlyClientsCanStartOrders: 'يمكن للعملاء فقط بدء الطلبات',
	maxValueRange: 'يجب أن تكون القيمة القصوى بين 1 و 1000000.',
	noteMinLength: 'يجب أن يتجاوز طول الملاحظة 20 حرفًا',
	noteMaxLength: 'يجب أن يكون طول الملاحظة أقل من 1000 حرف',
	cantOpenOrderNows: 'لا يمكنك بدء طلب جديد لأن لديك طلبًا غير مكتمل',
	amountLessThanMerchantAvailable: 'المبلغ أقل من المتاح لدى التاجر',
	amountLessThanYourBalanceLimit: 'يجب أن يكون المبلغ أقل من رصيدك',
	orderWith: 'صفقه مع',
	receivingPaymentFromBuyer: 'استلام المبلغ من المشتري',
	releasePaymentToBuyer: 'تحرير المبلغ للمشتري ',
	opened: 'مفتوح',
	appeal: 'إعتراض',
	onlyAppealIfProblemOrNoPayment: 'لا تعترض إلا في حالة وجود مشكلة أو عدم الدفع',
	expired: 'منتهي الصلاحية',
	placed: 'قيد المعالجة',
	unknown: 'غير معروف',
	pleaseWaitUntilMerchantAcceptOrder: 'يرجى الانتظار لحين موافقة التاجر على الطلب',
	pleaseAcceptTheOrderBeforeItsExpired: 'يرجى قبول الطلب قبل انتهاء صلاحيته',
	thisOrderHasBeenCanceled: 'تم إلغاء هذا الطلب',
	thisOrderHasBeenExpired: 'لقد انتهت صلاحية هذا الطلب',
	thisOrderHasBeenRejected: 'لقد تم رفض هذا الطلب',
	thisOrderIsInAppeal: 'هذا الطلب قيد الإعتراض',
	theOrderStateIsUnknown: 'حالة الطلب غير معروفة',
	writeReviewAboutTheMerchant: 'اكتب تعليقًا عن التاجر',
	reviewIsRequired: 'النقيم مطلوب',
	paymentDetails: 'تفاصيل الدفع',
	paymentCompleted: 'تم التسديد',
	accept: 'قبول',
	reject: 'رفض',
	finishedSuccessfully: 'تم الانتهاء بنجاح',
	chatIsDisabled: 'الدردشة غير متاحة',
	chatWithClient: 'تواصل مع العميل هنا',
	chatWithMerchant: 'تواصل مع التاجر هنا',
	areYouSureYouWantToAcceptOrder: 'هل أنت متأكد أنك تريد قبول هذا الطلب؟',
	cancelThisOrder: 'إلغاء هذا الطلب',
	inzoDoesnNotProvideAutomaticRefunds:
		'{{comapnyName}} لا توفر  عمليات استرداد تلقائية. لا تقم بإلغاء طلبك إذا كنت قد دفعت ولكنك لم تستلم المبلغ المدفوع، قم برفع شكوى إذا كنت بحاجة إلى مساعدة.',
	pleaseWait:
		'يُرجى الانتظار قليلاً ريثما يقوم التاجر بالموافقة على الطلب، تستغرق الموافقة عادةً من دقيقتين إلى خمس دقائق، أما إذا لم تعد ترغب بإتمام العملية فيمكنك إلغاء الطلب.',
	waitForReceivingConfirmation: 'يرجى انتظار تأكيد استلام الأموال',
	gotIt: 'فهمت',
	makeSureToContactMerchant:
		'يرجى التأكد من الاتصال بالتاجر قبل إجراء أي دفعة. {{companyName}} لن تكون مسؤولة عن أي نوع من الخسارة.',
	makeSureToContactClient:
		'يرجى التأكد من الاتصال بالعميل قبل إجراء أي دفعة. {{companyName}} لن تكون مسؤولة عن أي نوع من الخسارة.',
	importNote: 'ملاحظة مهمة',
	paymentCompletedNote1: 'يرجى التأكد من أنك قمت بتحويل الأموال بنجاح إلى البائع.',
	paymentCompletedNote2: 'ملحوظة: لا تقم بالمتابعة إذا لم تكن قد أكملت الدفع/ فقد يؤدي ذلك إلى تعليق الحساب.',
	sucessfullyCompletedPaymentToSeller: 'لقد أكملت الدفع للبائع بنجاح.',
	paymentReceivedNote1: 'يرجى التأكد من أنك قد تلقيت الأموال بنجاح من المشتري.',
	paymentReceivedNote2: 'ملحوظة: لا تقم بالمتابعة إذا لم تستلم المبلغ/ فقد يؤدي ذلك إلى تعليق الحساب.',
	conofirmYouReceivedPayment: 'تأكيد أنك قد تلقيت المبلغ.',
	sucessfullyCompletedPaymentToBuyer: 'لقد أكملت الدفع للمشتري بنجاح.',
	areYouSureYouWantToReject: 'هل أنت متأكد أنك تريد رفض هذا الطلب ؟',
	transferWasSentSuccessfully: 'تم إرسال النقل بنجاح إلى الجزء الآخر',
	accepted: 'وافقت',
	merchantAccepted: 'تمت الموافقة من قبل التاجر',
	orderAccepted: 'تمت الموافقة على الطلب',
	finishedSuccessfuly: 'تم الانتهاء بنجاح',
	typeMessageHere: 'اكتب رسالة هنا',
	markAllAsRead: 'تمت القراءة',
	chooseMerchantFromYourCountry: 'اختر تاجرًا من بلدك',
	feedbackOnThisOrder: 'تعليقات على هذا الطلب',
	visit: 'عرض',
	newReview: 'تعليق جديد',
	seeOrderDetails: 'انظر تفاصيل الطلب',
	pleaseWaitUntilThePaymentIsReleased: 'يرجى الانتظار حتى يتم تحرير الدفع',
	waitUntilMerchantReleasesPayment: 'انتظر حتى يقوم التاجر بتحرير المبلغ',
	waitUntilClientTransfersPayment: 'انتظر حتى يقوم العميل بتحويل المبلغ',
	waitUntilMerchantConfirmsReceivingPayment: 'انتظر حتى يؤكد التاجر استلام المبلغ',
	waitUntilClientConfirmsReceivingPayment: 'انتظر حتى يؤكد العميل استلام المبلغ',
	paymentTransfered: 'تم تحويل المبلغ',
	inzoDoesNotProvideAutoRefund:
		'{{comapnyName}} لا توفر  عمليات استرداد تلقائية. يرجى تسجيل الدخول إلى حسابك للتحقق من حالة الدفع',
	iReceivedAmountFromBuyer: 'لقد تلقيت {{amount}} من المشتري.',
	iCheckedPaymentFrom: 'لقد تأكدت من أن المبلغ جاءت من {{userName}}',
	iAgreeToReleasePaymentToBuyer: 'أوافق على تحرير دفعتي للمشتري.',
	transferWasSentSuccessfullyClient: 'لقد قمت بشراء {{amount}} بنجاح من {{username}}',
	transferWasSentSuccessfullyMerchant: 'لقد قمت ببيع {{amount}} بنجاح إلى {{username}}',
	reviewSubmitted: 'تم تقديم التقيم بنجاح',
	notificationNewOrderMessage: `طلب {{orderType}} جديد #{{orderNumber}} بقيمة {{amount}} تم فتحه.`,
	notificationOrderNewMessage: `رسالة جديدة في الطلب #{{orderNumber}} في {{createdAt}}`,
	notificationOrderExpiryWarning: `طلبك #{{orderNumber}} على وشك الانتهاء في {{orderExpiresTimestamp}}`,
	notificationOrderExpired: `انتهى الطلب #{{orderNumber}}.`,
	notificationOrderStatusUpdate: `تغيير في حالة الطلب #{{orderNumber}}. {{orderStatusBefore}} ← {{orderStatusAfter}}`,
	notificationOfferDisabled: `تم سحب عرضك {{offerType}} بسبب {{reason}}`,
	notificationAccountBalanceLow: `رصيد حساب التاجر منخفض. الرصيد الحالي: {{amount}}`,
	notificationSellAvailableLow: `كمية عرض البيع التي حددتها على وشك النفاد. قم بتحديث الكمية لضمان صلاحية العرض. الرصيد الحالي للبيع المتاح: {{sellAvailable}}`,
	seeMore: 'انظر المزيد',
	noNotificationsFound: 'لم يتم العثور على اشعارات',
	totalOrder: 'جميع الطلبات',
	offerType: 'نوع الطلب',
	offerNotAvailable: 'هذا العرض غير متاح في الوقت الحالي.',
	errorProccessingMT5: 'حدث خطأ أثناء معالجة الطلب',
	amountDosentSatisfyLimit: 'المبلغ لا يلبي الحد المسموح به للعرض!',
	noteErrorMessage: 'يجب ألا تزيد الملاحظة عن 1000 حرف!',
	type: 'النوع',
	resonsForCancellation: 'سبب الغاء الطلب ',
	resonsForCancellationNote:
		'لتجنب الخسارة لا تقم بإلغاء الطلب بعد إجراء الدفع,{{comapnyName}} ليست مسؤولة عن أي نوع من الخسارة',
	unableToMakePayment: 'غير قادر على إجراء الدفع',
	dontKnowHowToPay: 'لا أعرف كيف أدفع',
	discussedWithSeller: 'ناقشت مع البائع عدم المتابعة',
	poorSellerAttitude: 'سوء معاملة البائع',
	cantContactSeller: 'لا يمكن الاتصال بالبائع',
	suspectSellerFraud: 'تشك في احتيال البائع',
	others: 'سبب أخر',
	userSuspend: 'تم تعطيل حسابك',
	userBlock: 'تم حظر حسابك',
	userUnblock: 'تم رفع الحظر على حسابك',
	userUnsuspend: 'تم رفع التعطيل على حسابك',
	accessDenied: 'تم الرفض',
	chatHasBeenClosed: 'تم إغلاق الدردشة',
	emailAlreadyExist: 'البريد الالكتروني موجود مسبقا',
	phoneNumberDoesNotMatchTheRequirement: 'رقم الهاتف لا يطابق المتطلبات',
	newPasswordAndConfirmPasswordNotSame: 'كلمة المرور الجديدة وتأكيد كلمة المرور يجب ان يتطابقوا',
	userIsBlocked: 'تم حظر المستخدم',
	userIsSuspended: 'تم تعليق المستخدم',
	invalidOTP: 'كلمة المرور لمرة واحدة غير صالحة',
	merchantNotFound: 'لم يتم العثور على التاجر',
	cancelAppeal: 'الغاء الإعتراض',
	revert: 'تم العودة للخطوة السابقة',
	release: 'تحرير المبلغ',
	copiedSuccessfully: 'تم النسخ بنجاح',
	userSuspended: 'المستخدم موقوف',
	merchantNewReview: 'تقيم جديد',
	withdrawal: 'سحب',
	deposit: 'إيداع',
	chatnow: 'تواصل الان',
	expireIn: 'ينتهي في خلال',
	releasePayment: 'تحرير المبلغ للمشتري',
	paywith: '{{method}}ادفع عن طريق',
	notFound: 'رقم الطلب غير موجود',
	invalidType: 'امتداد الملف غير صالح. يرجى تحميل ملف بتنسيق JPG، JPEG، PNG، أو PDF.',
	fileExceedLimit: 'حجم الملف يتجاوز الحد المسموح به (5 ميجابايت).',
	accountLimit: 'حد الحساب',
	maxValueAvailable: 'المبلغ أكبر من المتاح',
	cannotEnableOffer: 'لا يمكن تفعيل العرض بسبب عدم وجود رصيد كافي',
	show: 'عرض',
	entries: 'صفوف',
	sortBy: 'ترتيب ',
	startDate: 'بدايه التاريخ',
	endDate: 'نهايه التاريخ',
	enterYourOtp: 'أدخل رمز التحقق الخاص ببريدك الإلكتروني',
	amountmustbelessThanavailabel: 'يجب أن يكون المبلغ أقل من الرصيد المتاح {{amount}} {{currency}}',
	amountmustbeBiggerThanMinmum: 'يجب أن يكون المبلغ أكبر من الحد الأدنى',
	minAllowedValue: 'يجب أن يكون الحد الأدنى للمبلغ أكبر من أو يساوي {{amount}} {{currency}}',
	maxAllowedValue: 'يجب أن يكون الحد الأقصى للمبلغ أقل من أو يساوي {{amount}} {{currency}}',
	priceLow: 'أقل سعر',
	priceHight: 'أعلى سعر',
	didNotreceiveOtp: 'لم تستلم الرمز؟',
	resend: 'اعاده ارسال',
	withdrawalOffer: 'عرض سحب',
	depositOffer: 'عرض إيداع',
	NEW_ORDER: 'طلب جديد',
	ORDER_NEW_MESSAGE: 'رسالة جديدة في الطلب',
	ORDER_EXPIRY_WARNING: 'تحذير انتهاء الطلب',
	ORDER_EXPIRED: 'انتهت صلاحية الطلب',
	ORDER_STATUS_UPDATE: 'تحديث حالة الطلب',
	OFFER_DISABLED: 'العرض تم تعطيله',
	ACCOUNT_BALANCE_LOW: 'رصيد الحساب منخفض',
	SELL_AVAILABLE_LOW: 'توفر البيع منخفض',
	MERCHANT_NEW_REVIEW: 'تقييم تاجر جديد',
	USER_SUSPEND: 'تعليق المستخدم',
	USER_UNSUSPEND: 'إلغاء تعليق المستخدم',
	USER_BLOCK: 'حظر المستخدم',
	USER_UNBLOCK: 'رفع حظر المستخدم',
	unitPriceChange: 'تغير سعر الوحدة. يرجى مراجعة الأسعار الجديدة قبل تقديم الطلب',
	allowBalance: 'يرجى إيداع {{amount}} دولار أمريكي لتمكين العروض.',
	priceChange: 'تغير السعر',
	YouReceive: 'تستلم',
	Youpay: 'مبلغ الدفع',
	Seeorderdetails: 'رؤية تفاصيل الطلب',
	INSUFFICIENT_BALANCE: 'رصيد غير كافي',
	COOLDOWN: 'فترة خمول',
	BY_ADMIN: 'بواسطة المشرف',
	termsAndConditionError: 'لم يقبل التاجر الشروط والأحكام',
	termsAndConditionsTitle: 'شروط وأحكام تجار webatts',
	acceptTerms: 'أوافق على الشروط والأحكام',
	aggree: 'موافق',
	RegistrationAndqualification: 'التسجيل والتأهيل',
	RegistrationAndqualification1: 'يجب على التجار التسجيل كتاجر webatts وتقديم المعلومات المطلوبة للتأهيل.',
	RegistrationAndqualification2:
		'يجب على التجار تقديم وثائق هوية صالحة مع إثبات الإقامة، وسيتم عقد اجتماع مع التاجر لمصادقة حسابه.',
	RegistrationAndqualification3: 'التأهيل يخضع لموافقة الشركة، ويمكن تعديل الشروط في أي وقت.',
	TransactionsAndfees: 'المعاملات والرسوم',
	TransactionsAndfees1: 'يجب على التجار الامتثال للرسوم والأسعار المعتمدة لخدمة webatts Merchant.',
	TransactionsAndfees2: 'تحتفظ الشركة بالحق في تحديث الرسوم والأسعار وإعلام التجار بذلك.',
	CommitmentTosafety: 'التزام بالسلامة',
	CommitmentTosafety1: 'يجب على التجار اتخاذ تدابير أمان صارمة لحماية معلومات العملاء والمعاملات.',
	CommitmentTosafety2: 'يجب توفير بيئة آمنة ومأمونة لإجراء المعاملات.',
	Compliancewithlawsandregulations: 'الامتثال للقوانين واللوائح',
	Compliancewithlawsandregulations1:
		'يجب على التجار الامتثال لجميع القوانين واللوائح المتعلقة بالخدمات المالية و webatts Merchant.',
	Positiveinteractionwithcustomers: 'تفاعل إيجابي مع العملاء',
	Positiveinteractionwithcustomers1:
		'يجب على التجار التفاعل بشكل إيجابي مع العملاء وتقديم الدعم الفعّال والسرعة في تنفيذ الطلبات. يجب حل الشكاوى والمشاكل بسرعة وفعالية.',
	Terminationofservice: 'إنهاء الخدمة',
	Terminationofservice1: 'تحتفظ الشركة بالحق في إنهاء خدمة التاجر إذا لم يتم الامتثال للشروط والأحكام المتفق عليها.',
	send: 'ارسل',
	amountDoesNotSatisfyAccountGroupLimit: 'المبلغ لايلبي الحد المسموح في الحساب',
	limitReached: 'تجاوزت حد طلبات التاجر!',
	OTPIsrequired: 'الرمز السري مطلوب!',
	Pleaseuploadthepaymentproof: 'يرجى تحميل إثبات الدفع',
	ChooseFile: 'اختر الملف',
	selectPaymentProof: 'اختر إثبات الدفع',
	fileUploadRequired: 'الملف مطلوب',
	download: 'تحميل',
	live: 'نشط',
	chatNoInternet: 'لا يوجد اتصال بالإنترنت',
	chatReconnecting: 'اتصالك بالإنترنت بطيء. قد تستغرق الرسائل بعض الوقت للظهور',
	chatConnectionRestored: 'تم الاتصال',
	pullToRefresh: 'اسحب للأسفل للتحديث',
	releaseToRefresh: 'أفلت للتحديث',
	refreshingMessages: 'جارٍ التحديث…',
	actionNotConfirmed: 'تعذر تأكيد الإجراء بسبب بطء الاتصال. يرجى التحقق من حالة الطلب قبل المحاولة مرة أخرى.',
	submit: 'ارسال',
	back: 'عودة',
	of: 'من',
	items: 'عنصر',
	agent: 'المشرف',
	tradersRoom: 'بوابه العميل',
	navMyOrders: 'طلباتي',
	navMerchants: 'التجار',
	navWallet: 'محفظتي',
	navMyOffers: 'عروضي',
	navTermsAndConditions: 'الشروط',
	navTradersRoom: 'البوابة',
	exchangeRateUpdate: 'تم تغيير سعر الصرف من {{oldExchangeRate}} إلى {{newExchangeRate}} بواسطة {{role}}.',
	EXCHANGE_RATE_UPDATE: 'تحديث سعر الصرف',
	ORDER_REJECTION_WARNING: 'تحذير رفض الطلب',
	sessionExpired: 'انتهت الجلسة',
	orderRejectionWarning: 'رفض الطلب مرة أخرى سيؤدي إلى تعطيل عروضك',
	suspendClient: 'تعليق العميل',
	suspendMerchant: 'تعليق التاجر',
	unsuspendMerchant: 'رفع تعليق التاجر',
	unsuspendClient: 'رفع تعليق العميل',
	restricted: 'مقيد',
	completionRate: 'مكتملة',
	otpexpired: 'لقد انتهت صلاحية رمز OTP!',
	reachedotplimit: 'لقد وصلت إلى الحد الأقصى لمحاولات رمز OTP!!',
	annoncement: '{{from}} - {{to}} سيكون هنالك صيانة في النظام مجدولة من ',
	createdAt: 'أنشئت في',
	searchWallet: 'بحث المعاملة',
	WALLET_BALANCE: 'رصيد المحفظة',
	WALLET: 'المحفظة',
	WALLET_DESCRIPTION: 'تدفق المعاملات، وتمكين الاتصالات: محفظتك للتبادل السلس عبر تقنية P2P',
	WITHDRAW_FROM_MT5: 'سحب من حساب التداول',
	DEPOSIT_TO_MT5: 'الإيداع الى حساب التداول',
	WALLET_AMOUNT: 'رصيد المحفظة ',
	WITHDRAW_COMMISSION: 'سحب العمولة',
	TRANSACTION_REPORT: 'تقرير المعاملات',
	TRANSACTION_REPORT_NOTE: 'يرجى ملاحظة أنك ستتلقى رسالة بريد إلكتروني بمجرد اكتمالها.',
	WALLET_ACCOUNTS: 'حسابات المحفظة',
	MY_WALLETS: 'محافظي',
	WALLET_NUMBER: 'رقم المحفظة',
	ON_HOLD_BALANCE: 'الرصيد المعلق',

	PENDING: 'قيد الانتظار',
	COMPLETED: 'مكتمل',
	REVERTED: 'عملية عكسية',
	PENDING_APPROVAL: 'قيد الموافقة',
	CANCELLED: 'ألغيت',
	P2P_BUY: 'شراء P2P',
	P2P_SELL: 'بيع P2P',
	P2P_REFUND: 'استرداد P2P',
	TRADING_DEPOSIT: 'إيداع إلى حساب التداول',
	TRADING_WITHDRAW: 'سحب من حساب التداول ',
	EXCHANGE: 'تبادل',
	MANUAL: 'يدوي',
	p2pBuyOrder: 'أمر شراء P2P',
	p2pSellOrder: ' أمر بيع P2P',
	depositToTradingAccount: ' إيداع في الحساب التداولي',
	withdrawFromTradingAccount: ' سحب من الحساب التداولي',

	amountshouldliebetween: 'القيمة يجب أن تكون بين {{min}} - {{max}} {{currency}}',

	withdrawRequesttitle: 'سحب من الحساب التداولي',
	confirmWithdrawalRequest: 'تأكيد طلب السحب',
	withdrawRequestSubtitle: 'سيتم تحويل المبلغ إلى محفظتك  في خلال بعض الوقت ',
	depositRequestTitle: 'إيداع في الحساب التداولي',
	depositRequestSubtitle: 'سيتم تحويل المبلغ إلى حساب التداول الخاص بك في غضون دقيقة.',
	commisionPercentage: 'نسبة العمولة',
	bounsPercentage: 'نسبة المكافأة',
	withdrawAmount: 'مبلغ السحب',
	depositAmount: 'مبلغ الإيداع',
	commisionAmount: 'مبلغ العمولة المعادل',
	bounsAmount: 'مبلغ المكافأة المعادل',
	withdrawRequest: 'طلب سحب',
	depositRequest: 'طلب إيداع',
	transactionId: 'الرقم التعريفي للمعامله',
	date: 'التاريخ',

	withdrawCommission: 'عمولة السحب',
	depositBouns: ' مكافأة الإيداع',

	Currencycodealreadyexist: 'كود العملة موجود بالفعل',
	Walletnotexist: 'المحفظة غير موجودة',
	Walletbalanceunsatisfied: 'رصيد المحفظة غير مرضي',
	Merchantwalletscurrencyisdifferent: 'عملة محافظ التجار مختلفة',
	Walletonholdbalanceunsatisfied: 'رصيد المحفظة المعلقة غير مرضي',
	Erroroccurredwhiledoingtransaction: 'حدث خطأ أثناء عملية التحويل',
	Youarenotallowedtoperformthisaction: 'غير مسموح لك بأداء هذا الإجراء',
	OrderWalletTransaction: 'معاملة المحفظة ',

	NEW_OPERATION: 'عملية جديدة',
	REQUEST_ACTION: 'طلب إجراء',
	requestAction: 'تم {{requestState}} طلب {{transactionType}} الخاص بك بمبلغ {{amount}}',
	newOperation: 'قمت بطلب {{transactionType}} بمبلغ {{amount}}',
	newOperationDeposit: 'قمت بـ {{transactionType}} بمبلغ {{amount}}',
	depositWithdrawRequest: 'أوافق على {{type}} {{amount}} لحساب التداول.',
	WithdrawRequest: 'أوافق على طلب السحب بمبلغ {{amount}} من حساب التداول',
	amountshouldLessThanwalletAvailable: 'يجب أن يكون المبلغ أقل من المتاح في المحفظه {{amount}}',
	credit: 'رصيد المكافئات',
	holdon: 'انتظر لحظة',
	youAreBeignRedirect: 'يتم إعادة توجيهك إلى P2P...',
	validationChatMessage: ' الأحرف الخاصة <, >, & غير مسموح بها.',
	youAreBeingRedirectBack: 'جاري إعادة توجيهك ...',
	showLiveChat: 'إظهار الدردشة المباشرة',
	hideLiveChat: 'إخفاء الدردشة المباشرة',
	noTradingAccountFound: 'لم يتم العثور على حساب تداول.',
	otpSendMessage: 'تم إرسال رمز التحقق بنجاح',
	amountNotSatisfyOfferLimit: 'المبلغ لا يفي بحد عرض التاجر {{min}} - {{max}} {{currency}}',
	amountLessMerchnat: 'يجب أن يكون المبلغ أقل من الرصيد المتاح للتاجر {{available}} {{currency}}',
	otpResendMessage: 'تم إعادة إرسال رمز التحقق بنجاح',
	UploadLivePicture: 'رفع صورة حية',
	Tips: 'نصائح',
	tipOne: 'تأكد من أن بياناتك واضحة وليست محجوبة.',
	tipTwo: 'التقط الصورة في مكان مضاء جيدًا لتجنب الظلال أو الوهج.',
	tipThree: 'الصور الضبابية أو غير الواضحة يمكن أن تجعل التحقق صعبًا.',
	tipFour: 'تجنب التقاط الصورة بزاوية تشوه الصورة.',
	FileExtensionNotSupported: 'صيغة الملف غير مدعومة',
	FileTooLarge: 'الملف كبير جدًا',
	InvalidFile: 'ملف غير صالح',
	ADMIN_WALLET_DEPOSIT: 'إيداع بواسطة المشرف',
	ADMIN_WALLET_WITHDRAW: 'سحب بواسطة المشرف',
	recaptchaError: 'تعذر إتمام طلبك. يرجى تحديث الصفحة والمحاولة مرة أخرى',
	termsAndConditionsBuyers: 'شروط وأحكام الشراء',
	termsAndConditionsSellers: 'شروط وأحكام البيع',
	SimultaneousTransactions: 'المعاملات المتزامنة غير مسموحة',
	availableDeposit: 'متاح للإيداع',
	minimumAmountDeposit: 'الحد الأقل للإيداع',
	maximumAmountDeposit: 'الحد الأقصى للإيداع',
	availableWithdraw: 'متاح للسحب',
	minimumAmountWithdraw: ' الحد الأقل للسحب',
	maximumAmountWithdraw: 'الحد الأعلى للسحب',
	'Currency/Wallet': 'رقم المحفظة/العملة',
	'Filter Options': 'خيارات التصفية',
	languageError: 'لا يمكن تحديث نفس اللغة',
	'TradingAccount(s)NotSupported': 'حساب(ات) التداول غير مدعومة في نظام P2P',
	noteIsRequred: 'يرجى إدخال ملاحظة',
	welcomeChatMessage: 'مرحبًا! ابدأ الدردشة لمعالجة الطلبات بسلاسة',
	Photos: 'صورة',
	Document: 'مستند',
	zoomIn: 'تكبير',
	zoomOut: 'تصغير',
	reset: 'إعادة ضبط',
	holidayDay: 'تم إيقاف النظام مؤقتًا بسبب العطلة',
	SystemIsPausedDueToHoliday: 'تم إيقاف النظام مؤقتًا بسبب العطلة',
	StartDateIsRequired: 'تاريخ البدء مطلوب',
	StartAndEndDatesIsRequired: 'تاريخا البدء والانتهاء مطلوبان',
	ErrorWeekDaysIsRequired: 'أيام الأسبوع مطلوبة',
	ErrorOccurredWhileProcessingYourRequest: 'حدث خطأ أثناء معالجة طلبك، يرجى المحاولة مرة أخرى.',
	MONDAY: 'الإثنين',
	TUESDAY: 'الثلاثاء',
	WEDNESDAY: 'الأربعاء',
	THURSDAY: 'الخميس',
	FRIDAY: 'الجمعة',
	SATURDAY: 'السبت',
	SUNDAY: 'الأحد',
	weekdayHoliday: '{{name}} سيتم إيقاف النظام مؤقتًا يوم {{weekdays}} بسبب ',
	dateRangeHoliday: '{{name}} سيتم إيقاف النظام مؤقتًا خلال {{startDate}} - {{endDate}} بسبب ',
	COUNTRY_CODE_UPDATE: 'تحديث كود الدولة',
	COUNTRY_CODE_UPDATE_MESSAGE: 'تم تغيير عملة الدولة من {{oldCurrency}} إلى {{newCurrency}}',
	withdraw: 'سحب',
	newOperationAutoApproval: 'لقد قمت بـ {{transactionType}} بمبلغ {{amount}}',
	userArchived: 'تمت أرشفة المستخدم',
	maximumCharLength: 'يجب أن يكون النص أقل من {{maxLength}} حرفًا',
	transferPayment: 'تحويل المبلغ',
	waitingForRelease: 'بانتظار تحرير المبلغ',
	waitingForPayment: 'بانتظار الدفع',
	youAreNottAllowed: 'هذا حسابك مخصص للسحب فقط يمكنك الايداع على حساب P2P المخصص لغرض الايداع والسحب',
	...termsConditionArabicGenerated,
};
